// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1r8Mj","responsiveCard":"Card_responsiveCard__wWzKg"};